import PropTypes from 'prop-types';
import React from 'react';

import SmartLink from '../SmartLink';
import { Share } from './IconListData';
import * as styles from './ShareIconList.module.css';

const ShareIconList = ({ url, title }) => {
  const items = Share.map((item, i) => {
    return (
      <li key={i}>
        <SmartLink title={item.title} to={encodeURI(item.url.replace(/<\?url>/g, url).replace(/<\?title>/g, title))}>
          {item.icon}
        </SmartLink>
      </li>
    );
  });

  return <ul className={[`unstyled-list ${styles.sharing}`].join(' ')}>{items}</ul>;
};

ShareIconList.propTypes = {
  /**
   * Full URL to the article
   */
  url: PropTypes.string.isRequired,
  /**
   * Title of the article
   */
  title: PropTypes.string.isRequired,
};

export default ShareIconList;
